import React, { useState, useEffect } from "react";
import Header from "../../commons/Header/Header";
import Sidebar from "../../commons/Sidebar/Sidebar";
import { useNavigate, useParams } from "react-router-dom";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";

function UpdateVariation() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [selectedIngredient, setSelectedVariation] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
  });

  useEffect(() => {
    const variationData = localStorage.getItem("selectedVariation");
    if (variationData) {
      const parsedData = JSON.parse(variationData);
      setSelectedVariation(parsedData);
      setFormData({
        name: parsedData.name || "",
      });
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.name.trim()) {
      toast.error("Please enter variation name");
      return;
    }

    const nameRegex = /^[A-Za-z\s]+$/;
    if (!nameRegex.test(formData.name.trim())) {
      toast.error("Variation name should only contain letters and spaces");
      return;
    }

    setLoading(true);
    try {
      const response = await handleApiCall("patch", `${endpoints.updateVariations}/${id}`, {
        name: formData.name.trim(),
      });

      if (response?.data?.code === 200) {
        toast.success(response?.data?.message || "Variation updated successfully!");
        localStorage.removeItem("selectedVariation");
        setTimeout(() => {
          navigate("/variations");
        }, 1000);
      }
      // API errors are already handled by handleApiCall
    } catch (error) {
      console.error("Error updating ingredient:", error);
      // Network errors are already handled by handleApiCall
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    localStorage.removeItem("selectedVariation");
    navigate("/variations");
  };

  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-3 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">Update Variation</h3>
            </div>
            <div className="mb-4 px-0 py-2">
              <div className="card-heading d-flex align-items-center mb-3 pb-2">
                <div className="d-flex align-items-center justify-content-start col-md-12 px-0">
                  <Button className="rounded-lg" onClick={handleSubmit} disabled={loading}>
                    {loading ? "Updating..." : "Update"}
                  </Button>
                  <Button className="rounded-lg ml-4 bg-white" onClick={handleCancel} disabled={loading}>
                    Cancel
                  </Button>
                </div>
              </div>
              <h5 className="text-white mt-4 mb-3">UPDATE Variation</h5>
              <form onSubmit={handleSubmit}>
                <div className="row mx-n2">
                  <div className="form-group col-md-6 px-2">
                    <label className="text-white mb-2">Variation Name *</label>
                    <input
                      type="text"
                      className="form-control default"
                      placeholder="Enter variation name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      disabled={loading}
                      required
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateVariation;
